/**
 * FE-C2g batch-4: OTA route — contract paths for ota.route.js.
 */

import { buildContractPath } from "./api/contract-client.js";

export const OTA_CONSOLE_TIMEOUT_MS = 20000;
export const OTA_DEVICES_LIST_TIMEOUT_MS = 28000;
export const OTA_VERIFY_UNLOCK_TIMEOUT_MS = 16000;
export const OTA_FIRMWARE_UPLOAD_TIMEOUT_MS = 180000;

export function buildPostAuthMeVerifyOtaUnlockPath() {
  return buildContractPath("post__auth_me_verify-ota-unlock");
}

export function buildOtaFirmwaresPath() {
  return buildContractPath("get__ota_firmwares");
}

export function buildPostOtaFirmwareUploadPath() {
  return buildContractPath("post__ota_firmware_upload");
}

export function buildPostOtaCampaignsFromStoredPath() {
  return buildContractPath("post__ota_campaigns_from-stored");
}

export function buildGetOtaCampaignsPath() {
  return buildContractPath("get__ota_campaigns");
}

/** @param {string} campaignId */
export function buildPostOtaCampaignAcceptPath(campaignId) {
  return buildContractPath("post__ota_campaigns_p_accept", {
    path: { param: String(campaignId || "").trim() },
  });
}

/** @param {string} campaignId */
export function buildPostOtaCampaignDeclinePath(campaignId) {
  return buildContractPath("post__ota_campaigns_p_decline", {
    path: { param: String(campaignId || "").trim() },
  });
}

/** @param {string} campaignId */
export function buildPostOtaCampaignRollbackPath(campaignId) {
  return buildContractPath("post__ota_campaigns_p_rollback", {
    path: { param: String(campaignId || "").trim() },
  });
}

/** @param {string} name — staged firmware filename */
export function buildOtaFirmwareReachabilityPath(name) {
  return buildContractPath("get__ota_firmware-reachability", {
    query: { name: String(name || "").trim() },
  });
}
